export default __webpack_public_path__ + "static/media/question.d449a31c.png";